import { countries } from 'countries-list';

export const getCountryNamesAndCodes = () => {
  return Object.keys(countries).map((countryCode) => ({
    label: `+${countries[countryCode].phone} ${countries[countryCode].name}`,
    value: countryCode,
  }));
};
